import { useMemo, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { SearchX } from "lucide-react";
import PageShell from "../components/PageShell";
import PageHeader from "../components/PageHeader";
import SearchBar from "../components/SearchBar";
import CargoCard from "../components/CargoCard";
import { CARGOS, CATEGORIES } from "../data/staffData";

export default function Hierarquia() {
    const [query, setQuery] = useState("");
    const [category, setCategory] = useState("Todos");

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        return CARGOS.filter(
            (c) =>
                (category === "Todos" || c.categoria === category) &&
                (!q ||
                    c.nome.toLowerCase().includes(q) ||
                    c.funcao.toLowerCase().includes(q) ||
                    c.rank.toLowerCase().includes(q))
        );
    }, [query, category]);

    return (
        <PageShell testid="page-hierarquia">
            <PageHeader
                eyebrow="Hierarquia"
                title="Cargos da Equipe Staff"
                description="Todos os cargos organizados por nível hierárquico, com funções, quotas e ranks. Cargo não é apenas posição, é responsabilidade."
            />
            <div className="mb-6 flex flex-col gap-4">
                <div className="max-w-md">
                    <SearchBar
                        value={query}
                        onChange={setQuery}
                        placeholder="Buscar por cargo, função ou rank..."
                        testid="search-input-hierarquia"
                    />
                </div>
                <div
                    data-testid="category-filters"
                    className="flex gap-2 overflow-x-auto pb-1"
                >
                    {["Todos", ...CATEGORIES].map((cat) => (
                        <button
                            key={cat}
                            data-testid={`filter-chip-${cat.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, "-")}`}
                            onClick={() => setCategory(cat)}
                            className={`shrink-0 rounded-full border px-4 py-1.5 text-xs font-semibold transition-all duration-200 ${
                                category === cat
                                    ? "border-violet-500/60 bg-violet-500/15 text-violet-200"
                                    : "border-white/10 bg-white/5 text-gray-400 hover:border-white/20 hover:text-gray-200"
                            }`}
                        >
                            {cat}
                        </button>
                    ))}
                </div>
            </div>
            <p
                data-testid="hierarquia-results-count"
                className="mb-5 font-code text-[11px] uppercase tracking-[0.2em] text-gray-500"
            >
                Exibindo {filtered.length} de {CARGOS.length} cargos
            </p>
            {filtered.length === 0 ? (
                <div
                    data-testid="hierarquia-empty-state"
                    className="glass-card flex flex-col items-center gap-3 rounded-2xl px-6 py-16 text-center"
                >
                    <SearchX className="h-8 w-8 text-gray-600" />
                    <p className="font-display text-lg font-bold text-gray-300">
                        Nenhum cargo encontrado
                    </p>
                    <p className="text-sm text-gray-500">
                        Ajuste a busca ou o filtro de categoria.
                    </p>
                </div>
            ) : (
                <motion.div layout className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                    <AnimatePresence mode="popLayout">
                        {filtered.map((cargo, i) => (
                            <CargoCard
                                key={cargo.slug}
                                cargo={cargo}
                                index={CARGOS.indexOf(cargo)}
                            />
                        ))}
                    </AnimatePresence>
                </motion.div>
            )}
        </PageShell>
    );
}
